<template>
  <i class="fa fa-fw fa-instagram"></i>
</template>

<script>
export default {
  name: 'Instagram',
};
</script>

<style scoped>
.fa-instagram {
  color: #ed1f65;
}
</style>



// WEBPACK FOOTER //
// InstagramIcon.vue?269063fe